import { getFirebase } from '@assets/firebase/FirebaseAdapater';
import { TaskEvalRule } from '@assets/model/Store';
import { onValue, ref, set } from 'firebase/database';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { Split } from '../Split/Split';
import { Flex } from '../UI/Flex/Flex';
import * as style from './EditEvalsComponent.module.less';
import { Button } from 'react-bootstrap';
interface EditEvalComponentProps {
    realtime_path: string;
}
const EditEvalComponent = observer((props: EditEvalComponentProps) => {
    const [evalList, setEvalList] = useState<{ [key: string]: TaskEvalRule }>(
        {}
    );

    const [selectedRuleId, setSelectedRuleId] = useState<string>(null);
    const [editRuleName, setEditRuleName] = useState<string>(null);
    const [editRuleEvalPrompt, setEditRuleEvalPrompt] = useState<string>(null);
    const [lastMessage, setLastMessage] = useState<string>('');

    useEffect(() => {
        if (!selectedRuleId) {
            setEditRuleName('');
            setEditRuleEvalPrompt('');
            return;
        }

        if (selectedRuleId && evalList[selectedRuleId]) {
            setEditRuleName(evalList[selectedRuleId].name);
            setEditRuleEvalPrompt(evalList[selectedRuleId].eval_prompt);
        }
    }, [selectedRuleId]);

    useEffect(() => {
        const path = props.realtime_path;
        const fb = getFirebase();
        const r = ref(fb.db, path);
        const unsub = onValue(r, snapshot => {
            const data = snapshot.val();
            console.log('EditEvalsComponent: fetched evals rules:', data);
            setEvalList(data ?? {});
        });

        return () => {
            unsub();
        };
    }, [props.realtime_path]);

    const ruleList = [];
    for (const key in evalList) {
        const entry = evalList[key];
        ruleList.push(
            <Flex
                direction="column"
                id={key}
                className={style.rule_entry}
                style={{
                    backgroundColor:
                        selectedRuleId == key ? 'lightblue' : 'white',
                    cursor: 'pointer'
                }}
                onClick={() => {
                    setSelectedRuleId(key);
                }}
            >
                <div>{key}</div>
            </Flex>
        );
    }
    const deleteEvalRule = async () => {
        if (!selectedRuleId) {
            return;
        }
        const areYouSure = window.confirm(
            'Are you sure you want to delete rule ' + selectedRuleId + '?'
        );
        if (!areYouSure) {
            return;
        }

        const fb = getFirebase();
        const r = ref(fb.db, `${props.realtime_path}/${selectedRuleId}`);
        await set(r, null);
        setLastMessage('Deleted rule ' + selectedRuleId);
        setSelectedRuleId(null);
    };

    const saveEvalRule = async () => {
        if (!selectedRuleId) {
            return;
        }
        const fb = getFirebase();
        const r = ref(fb.db, `${props.realtime_path}/${selectedRuleId}`);
        await set(r, {
            name: editRuleName,
            eval_prompt: editRuleEvalPrompt
        });
        setLastMessage('Saved rule ' + selectedRuleId);
    };

    const addNewRule = async () => {
        const newRuleId = prompt('Enter new rule ID:');
        if (!newRuleId) {
            return;
        }
        const fb = getFirebase();
        const r = ref(fb.db, `${props.realtime_path}/${newRuleId}`);
        await set(r, {
            name: 'New Rule',
            eval_prompt: 'Define the evaluation criteria here.'
        });
        setLastMessage('Added new rule ' + newRuleId);
    };
    const selectedRule = selectedRuleId ? evalList[selectedRuleId] : null;

    ruleList.push(<div style={{ flex: 1 }}></div>);
    ruleList.push(
        <Button
            onClick={() => {
                addNewRule();
            }}
        >
            Add New Rule
        </Button>
    );

    return (
        <Split layoutPercent={[30, 70]}>
            <Flex
                direction="column"
                fillCell={true}
                style={{ marginRight: '10px' }}
            >
                {ruleList}
            </Flex>
            <Flex
                fillCell={true}
                direction="column"
                style={{ marginLeft: '10px' }}
            >
                <div>Rule ID</div>
                <input
                    type="text"
                    placeholder="Rule ID"
                    value={selectedRuleId}
                    disabled={true}
                />
                <div>Rule Name</div>
                <input
                    type="text"
                    placeholder="Rule Name"
                    value={editRuleName}
                    onChange={e => setEditRuleName(e.target.value)}
                />
                <div>Rule Definition</div>
                <textarea
                    style={{ flex: 1 }}
                    placeholder="Rule Definition"
                    value={editRuleEvalPrompt}
                    onChange={e => setEditRuleEvalPrompt(e.target.value)}
                />
                <Flex
                    direction="row"
                    style={{ gap: '10px', paddingTop: '10px' }}
                >
                    <div style={{ flex: 1 }}>{lastMessage}</div>
                    <Button
                        onClick={() => {
                            deleteEvalRule();
                        }}
                    >
                        Delete
                    </Button>
                    <Button
                        onClick={() => {
                            saveEvalRule();
                        }}
                    >
                        Save
                    </Button>
                </Flex>
            </Flex>
        </Split>
    );

    //<div>{JSON.stringify(evalList, null, 2)}</div>;
});

export default EditEvalComponent;
